import vue from 'vue';
import { Loading } from 'element-ui'
import { registerMicroApps, start } from 'qiankun'
import appInfo from '../config/url'
import lifeCycles from './lifeCycles'
import setTheme from './setTheme';
import i18n from '../locale'
const container = '#appContainer'
const initialState = vue.observable({
  apiBaseURL: appInfo.API,
  loading: null,
  parent: 0,
  a: 0,
  current_language:localStorage.getItem('current_language')
})

const time = new Date().getTime()
const getEntry = (url, prefix) => {
  const env = process.env.NODE_ENV === 'dev'
  if (env) {
    return url
  } else {
    const hostname = window.location.hostname;
    const urlArr = hostname.split('.')
    let testEnv = urlArr[urlArr.length - 3]  //[hrss-main,testing3,wdeduc,com]

    if(testEnv && (['uat', 'fat'].includes(testEnv) || testEnv.includes('testing') || testEnv.includes('dev'))){
      return `${prefix}.${testEnv}.wdeduc.com?t=${time}` //   http://hrss-main.testing3.wdeduc.com
      // return `${prefix}.testing2.wdeduc.com?t=${time}` //临时访问2环境项目
    }else{
      return `${prefix}.wdeduc.com?t=${time}` //   http://hrss-main.wdeduc.com
    }
  }
}

const loader = (is) => {
  if (!localStorage.getItem('token')) {
    console.log('跳转登录')
    return
  }
  if (is) {
    initialState.loading = Loading.service({
      lock: true,
      text: i18n.t('MAIN_WEB_LOAD_INTO_MODULE',{text:'载入模块中。。。	'}),
      // text:'载入模块中。。。',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0)',
      customClass: 'el-color-loading'
    })
  } else {
    initialState.loading.close()
  }
}


const microApps = (props = {}) => {
  props.Vue.prototype.$appData = initialState
  props.$appData = initialState
  const prefetch = []
  const apps = appInfo.appInfo.map(item => {
    prefetch.push(item.name)
    const route = `/${item.name}`
    item.activeRule = route
    if (item.name === 'cms') {
      item.entry = getEntry(item.dev, `https://cms-admin`)
    } else if (item.name === 'payment') {
      item.entry = getEntry(item.dev, `https://pay-admin`)
    }
    else if (item.name === 'modular') {
      item.entry = getEntry(item.dev, `https://modular-admin-fe`)
      console.log(item, "DDDDDDDDDDDD")

    }  else if (item.name === 'form') {
      item.entry = getEntry(item.dev, `https://questionnaire-admin`)
    } else if (item.name === 'custom') {
      item.entry = getEntry(item.dev, `https://biz-admin`)
    } else if (item.name === 'govern-system') {
        item.entry = getEntry(item.dev, `https://govern-system`)
    } else if (item.name === 'daas') {
      item.entry = getEntry(item.dev, `https://dp-daas`)
   }  else if (item.name === 'c-admin') {
      item.entry = getEntry(item.dev, `https://c-admin`)
    }else if(item.name === 'jhh-admin') {
      item.entry = getEntry(item.dev, `https://jhh-admin`)
    }else if(item.name === 'lowcode-admin') {
      item.entry = getEntry(item.dev, `https://lowcode-admin`)
    }else if(item.name === 'traffic') {
      item.entry = getEntry(item.dev, `https://traffic-admin`)
    }else if(item.name === 'xwqh-admin') {
      item.entry = getEntry(item.dev, `https://xwqh-admin`)
    }
    else {
      item.entry = getEntry(item.dev, `https://hrss-${item.name === 'saas' ? 'admin' : item.name}`)
    }
    item.props = props
    item.container = container
    item.loader = loader
    return item
  })

  registerMicroApps(apps, lifeCycles)

  // setDefaultMountApp('/b')
  // setTheme.getTheMe()
  start({
    prefetch: true,
    sandbox: {
      experimentalStyleIsolation: true
    },
    singular: true
    // 自定义的子应用请求方法
    // fetch: (url) => {
    //   console.log('fetch: (url)', url)
    // }
  })
  // setTheme.getTheMe()
}

export default microApps
